// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { KindParentalSetting } from "../schema";

export function serialize_KindParentalSetting_internal(value: KindParentalSetting): unknown {
  return ((value: "parental-setting"): unknown => {
    return value;
  })(value);
}
export function serialize_KindParentalSetting(obj: KindParentalSetting): string {
  return renderJsonWithNumbersAsBigint(serialize_KindParentalSetting_internal(obj));
}
export function deserialize_KindParentalSetting_internal(value: unknown): ParserResult<KindParentalSetting> {
  return ((value: unknown): ParserResult<"parental-setting"> => {
    if (typeof value !== "string") {
      return { success: false, reason: `[#/components/schemas/KindParentalSetting]: '${value}' expected to be of type string.` };
    }
    switch (value) {
      case "parental-setting":
        return { success: true, value: "parental-setting" };
      default:
        return { success: false, reason: `[#/components/schemas/KindParentalSetting]: '${value}' expected to be enum, one of 'parental-setting'.` };
    }
  })(value);
}
export function deserialize_KindParentalSetting(str: string): ParserResult<KindParentalSetting> {
  return deserialize_KindParentalSetting_internal(parseJsonWithNumbersAsBigint(str));
}
